import { Dimensions, StyleSheet } from "react-native";
import { Colors } from "../../../../globalStyles/ColorConfig";
const windowHeight = Dimensions.get("window").height;
const styles = StyleSheet.create({
  Button: {
    backgroundColor: "#C0A46F",
    width: 70,
    height: 70,
    borderRadius: 50,
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    marginTop: 40,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.4,
    shadowRadius: 10,
    elevation: 1,
  },
  Grad: {
    position: "absolute",
    bottom: 1,
    width: "100%",
    transform: [{ scale: 1.1 }],
    // height: windowHeight * 0.3,
    zIndex: 1,
  },
  close: {
    position: "absolute",
    top: 50,
    right: 20,

    zIndex: 2,
  },
  Star: {
    position: "absolute",
    top: "40%",
    left: "40%",
    zIndex: 2,
  },
  MatchContainerWrap: {
    overflow: "hidden",
  },
  MatchContainer: {
    flexDirection: "row",
    transform: [
      { rotate: "6deg" },
      {
        scale: 1.2,
      },
    ],
    justifyContent: "space-between",
    alignItems: "center",
    height: windowHeight * 0.6,
    width: "100%",
  },
  MatchContainerImg: {
    width: "50%",
    height: "100%",
    objectFit: "cover",
  },
  Container: {
    flex: 1,
    width: "100%",

    backgroundColor: Colors.darkGreen,
  },
});

export default styles;
